import { InventoryMovementSummaryListPage } from "@/features/inventory-movement-summary/pages/InventoryMovementSummaryListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/inventory-movement-summary/")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["inventory_summary.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: InventoryMovementSummaryListPage,
});
